<section class="bb-page">
  <div class="bb-page-shell">

    <!-- HEADER -->
    <div class="bb-page-header">
      <div class="bb-inline-flex bb-items-center bb-gap-16">


        <div class="bb-page-title-block">
          <span class="bb-eyebrow">{{ 'expenses & revenue' | transloco }}</span>
          <h2 class="bb-page-title">{{ 'expenses & revenue' | transloco }}</h2>
        </div>
      </div>

      <div class="bb-header-actions noPrint">
        <button class="bb-btn bb-btn-primary" (click)="addRevenues()">
          <i class="fa-solid fa-plus"></i>
          {{ 'Add Revenue' | transloco }}
        </button>

        <button class="bb-btn bb-btn-danger" (click)="addExpenses()">
          <i class="fa-solid fa-minus"></i>
          {{ 'Add expenses' | transloco }}
        </button>
      </div>
    </div>

    <!-- ACTIONS -->
    <div class="bb-filter-card noPrint">
      <div class="bb-header-actions">

        @if(isAdmin){
        <div class="bb-action-dropdown dropdown">
          <button class="bb-btn bb-btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
            {{ "Pospage" | transloco }}
          </button>

          <ul class="bb-dropdown-menu dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li *ngFor="let el of allWareHouses; let i = index">
              <a class="bb-dropdown-item dropdown-item" (click)="applyWareHouse(el.id)">
                {{el.name}}
              </a>
            </li>
          </ul>
        </div>

        <div class="bb-action-dropdown dropdown">
          <button class="bb-btn bb-btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="8" r="4" stroke="#2A7DE1" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M4 20C4 16.5 7.5 14 12 14C16.5 14 20 16.5 20 20" stroke="#2A7DE1" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            {{ "Users" | transloco }}
          </button>

          <ul class="bb-dropdown-menu dropdown-menu">
            <li>
              <a class="bb-dropdown-item dropdown-item" (click)="userFilter(null)">
                {{ "All Users" | transloco }}
              </a>
            </li>

            <li *ngFor="let el of allUsers">
              <a class="bb-dropdown-item dropdown-item" (click)="userFilter(el.id)">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="8" r="4" stroke="#2A7DE1" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M4 20C4 16.5 7.5 14 12 14C16.5 14 20 16.5 20 20" stroke="#2A7DE1" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                {{ el.username }}
              </a>
            </li>
          </ul>
        </div>

        <button class="bb-btn bb-btn-secondary" routerLink="/employeescollecting">
          {{ 'employeescollecting' | transloco }}
        </button>

        <button class="bb-btn bb-btn-secondary" routerLink="/orderprofit">
          {{ 'orderprofit' | transloco }}
        </button>

        <button *ngIf="canShowDeliveryHeroCollecting" class="bb-btn bb-btn-secondary" routerLink="/deliveryherocollecting">
          {{ 'delivery hero collecting' | transloco }}
        </button>

        <button (click)="getArchivedBalances()" class="bb-btn bb-btn-secondary">
          {{ 'deleted archive' | transloco }}
        </button>

        @if(warehouseIsStore){
        <button routerLink="/financial-manager" class="bb-btn bb-btn-secondary">
          {{ 'affiliation revenue' | transloco }}
        </button>
        }
        }

        <button class="bb-btn bb-btn-outline" (click)="toggleExpenses()">
          {{ showExpenses ? ('Hide Expenses' | transloco) : ('Show Expenses' | transloco) }}
        </button>

        <button class="bb-btn bb-btn-outline" (click)="toggleRevenues()">
          {{ showRevenues ? ('Hide Revenues' | transloco) : ('Show Revenues' | transloco) }}
        </button>

        <button class="bb-btn bb-btn-secondary" onclick="window.print()">
          {{ 'Print' | transloco }}
        </button>

      </div>
    </div>

    <!-- FILTERS -->
    <div class="bb-filter-card noPrint">
      <div class="bb-form-grid">

        <div class="bb-field">
          <label class="bb-label">{{ 'byday' | transloco }}</label>

          <div class="bb-booking-calendar-field" [dir]="isAr ? 'rtl' : 'ltr'">
            <button
              type="button"
              class="bb-booking-calendar-trigger"
              (click)="toggleDayCalendar()"
              [ngClass]="{
                'is-valid': day
              }"
            >
              <span>{{ getDayDisplay() }}</span>
              <i class="fa-solid fa-calendar-days"></i>
            </button>

            @if(showDayCalendar) {
            <div class="bb-booking-calendar-panel">
              <div class="bb-booking-calendar-head">
                <button type="button" (click)="previousDayCalendarMonth()">
                  <i class="fa-solid" [ngClass]="isAr ? 'fa-chevron-right' : 'fa-chevron-left'"></i>
                </button>

                <strong>{{ getDayCalendarTitle() }}</strong>

                <button type="button" (click)="nextDayCalendarMonth()">
                  <i class="fa-solid" [ngClass]="isAr ? 'fa-chevron-left' : 'fa-chevron-right'"></i>
                </button>
              </div>

              <div class="bb-booking-calendar-weekdays">
                @for(dayName of getDayCalendarWeekDays(); track dayName) {
                <span>{{ dayName }}</span>
                }
              </div>

              <div class="bb-booking-calendar-grid">
                @for(calendarDay of getDayCalendarDays(); track calendarDay.date.getTime()) {
                <button
                  type="button"
                  class="bb-booking-calendar-day"
                  [class.other-month]="!calendarDay.isCurrentMonth"
                  [class.today]="calendarDay.isToday"
                  [class.selected]="calendarDay.isSelected"
                  [disabled]="calendarDay.isDisabled"
                  (click)="selectDayCalendarDate(calendarDay.date)"
                >
                  {{ calendarDay.dayNumber }}
                </button>
                }
              </div>
            </div>
            }
          </div>
        </div>

        <div class="bb-field">
          <label class="bb-label">{{ 'bymonth' | transloco }}</label>
          <div class="bb-flex bb-gap-8">
            <div class="bb-select-wrap bb-w-100">
              <select class="bb-select" [(ngModel)]="selectedYear" (change)="getByMonth()">
                <option *ngFor="let year of years" [value]="year">
                  {{ year }}
                </option>
              </select>
            </div>

            <div class="bb-select-wrap bb-w-100">
              <select class="bb-select" [(ngModel)]="selectedMonth" (change)="getByMonth()">
                <option *ngFor="let month of months" [value]="month.value">
                  {{ isAr ? month.name_ar : month.name_en }}
                </option>
              </select>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- SUMMARY -->
    <div class="finance-summary-head">
      <h3>{{ 'Summary' | transloco }}</h3>
    </div>

    <div class="finance-summary-grid">

      <div class="finance-summary-card">
        <div class="finance-summary-card-head">
          <h6>{{ 'total' | transloco }} {{ 'Revenue' | transloco }}</h6>
        </div>
        <h3 class="finance-value-success">
          {{ revenueTotal | number:'1.2-2' }} {{ 'egp' | transloco }}
        </h3>
      </div>

      <div class="finance-summary-card">
        <div class="finance-summary-card-head">
          <h6>{{ 'Revenue' | transloco }} {{ 'payment_type' | transloco }}</h6>
        </div>

        <div class="finance-mini-lines">
          <p>
            <strong>{{ 'online payment' | transloco }}:</strong>
            <span class="finance-value-success">
              {{ revenueTotalOnlinePayment | number:'1.2-2' }} {{ 'egp' | transloco }}
            </span>
          </p>

          <p>
            <strong>{{ 'cash' | transloco }}:</strong>
            <span class="finance-value-success">
              {{ revenueTotalCash | number:'1.2-2' }} {{ 'egp' | transloco }}
            </span>
          </p>
        </div>
      </div>

      <div class="finance-summary-card">
        <div class="finance-summary-card-head">
          <h6>{{ 'total' | transloco }} {{ 'expenses' | transloco }}</h6>
        </div>
        <h3 class="finance-value-danger">
          {{ expenseTotal | number:'1.2-2' }} {{ 'egp' | transloco }}
        </h3>
      </div>

      <div class="finance-summary-card">
        <div class="finance-summary-card-head">
          <h6>{{ 'expenses' | transloco }} {{ 'payment_type' | transloco }}</h6>
        </div>

        <div class="finance-mini-lines">
          <p>
            <strong>{{ 'online payment' | transloco }}:</strong>
            <span class="finance-value-danger">
              {{ expenseTotalOnlinePayment | number:'1.2-2' }} {{ 'egp' | transloco }}
            </span>
          </p>

          <p>
            <strong>{{ 'cash' | transloco }}:</strong>
            <span class="finance-value-danger">
              {{ expenseTotalCash | number:'1.2-2' }} {{ 'egp' | transloco }}
            </span>
          </p>
        </div>
      </div>

      <div class="finance-summary-card finance-summary-card-net">
        <div class="finance-summary-card-head">
          <h6>{{ 'Revenue' | transloco }} - {{ 'expenses' | transloco }}</h6>
        </div>

        <h3 [ngClass]="{
          'finance-value-success': revenueTotal - expenseTotal > 0,
          'finance-value-danger': revenueTotal - expenseTotal < 0
        }">
          {{ revenueTotal - expenseTotal | number:'1.2-2' }} {{ 'egp' | transloco }}
        </h3>
      </div>

    </div>

    <!-- TABLES -->
    <div class="finance-tables-grid">

      <app-loading *ngIf="contentReady"></app-loading>

      <!-- ================= EXPENSES ================= -->
      <div *ngIf="showExpenses" [ngClass]="{
        'finance-table-full': showExpenses && !showRevenues
      }">

        <div class="finance-table-card">
          <h5 class="finance-table-title finance-value-danger">
            {{ 'expenses' | transloco }}
          </h5>

          <div class="finance-table-scroll">
            <table class="finance-table">
              <thead>
                <tr>
                  <th>{{ 'amount' | transloco }}</th>
                  <th>{{ 'payment_type' | transloco }}</th>
                  <th>{{ 'reason' | transloco }}</th>
                  <th>{{ 'admin' | transloco }}</th>
                  <th class="noPrint"></th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let ex of expenses">
                  <td>
                    <strong class="finance-value-danger">
                      {{ ex.amount }} {{ 'egp' | transloco }}
                    </strong>
                  </td>

                  <td>
                    <span class="finance-status-badge" [ngSwitch]="ex.amount_type">
                      <span *ngSwitchCase="'0'">{{ "cash" | transloco }}</span>
                      <span *ngSwitchCase="'1'">{{ "vodafone cash" | transloco }}</span>
                      <span *ngSwitchCase="'2'">{{ "instapay" | transloco }}</span>
                      <span *ngSwitchCase="'3'">{{ "online payment" | transloco }}</span>
                      <span *ngSwitchCase="'4'">{{ "bank transfer" | transloco }}</span>
                      <span *ngSwitchCase="'5'">{{ "credit" | transloco }}</span>
                    </span>
                  </td>

                  <td>
                    <div class="finance-main-text">
                      {{ ex.note }}
                    </div>
                    <small class="finance-muted-text">
                      {{ translateTypeEnum(ex.type) }}
                    </small>
                  </td>

                  <td>
                    <div class="finance-main-text">
                      {{ ex.username }}
                    </div>
                    <span *ngIf="ex.deleted_by" class="finance-status-badge finance-status-danger">
                      {{ 'deleted by' | transloco }} :
                      {{ ex.deleted_by }}
                    </span>
                  </td>

                  <td class="noPrint finance-actions-cell">
                    <button *ngIf="!ex.deleted_by" (click)="delete(0,ex.id)" class="finance-delete-btn">
                      <i class="fa-solid fa-xmark"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- ================= REVENUES ================= -->
      <div *ngIf="showRevenues" [ngClass]="{
        'finance-table-full': showRevenues && !showExpenses
      }">

        <div class="finance-table-card">
          <h5 class="finance-table-title finance-value-success">
            {{ 'Revenue' | transloco }}
          </h5>

          <div class="finance-table-scroll">
            <table class="finance-table">
              <thead>
                <tr>
                  <th>{{ 'amount' | transloco }}</th>
                  <th>{{ 'payment_type' | transloco }}</th>
                  <th>{{ 'reason' | transloco }}</th>
                  <th>{{ 'admin' | transloco }}</th>
                  <th class="noPrint"></th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let Revenue of Revenues">
                  <td>
                    <strong class="finance-value-success">
                      {{ Revenue.amount }} {{ 'egp' | transloco }}
                    </strong>
                  </td>

                  <td>
                    <span class="finance-status-badge" [ngSwitch]="Revenue.amount_type">
                      <span *ngSwitchCase="'0'">{{ "cash" | transloco }}</span>
                      <span *ngSwitchCase="'1'">{{ "vodafone cash" | transloco }}</span>
                      <span *ngSwitchCase="'2'">{{ "instapay" | transloco }}</span>
                      <span *ngSwitchCase="'3'">{{ "online payment" | transloco }}</span>
                      <span *ngSwitchCase="'4'">{{ "bank transfer" | transloco }}</span>
                      <span *ngSwitchCase="'5'">{{ "credit" | transloco }}</span>
                    </span>
                  </td>

                  <td>
                    <div class="finance-main-text">
                      {{ Revenue.note }}
                    </div>
                    <small class="finance-muted-text">
                      {{ translateTypeEnum(Revenue.type) }}
                    </small>
                  </td>

                  <td>
                    <div class="finance-main-text">
                      {{ Revenue.username }}
                    </div>
                    <span *ngIf="Revenue.deleted_by" class="finance-status-badge finance-status-danger">
                      {{ 'deleted by' | transloco }} :
                      {{ Revenue.deleted_by }}
                    </span>
                  </td>

                  <td class="noPrint finance-actions-cell">
                    <button *ngIf="!Revenue.deleted_by" (click)="delete(1,Revenue.id)" class="finance-delete-btn">
                      <i class="fa-solid fa-xmark"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </div>

  </div>
</section>

<!-- POPUP -->
<div *ngIf="showFinPopUp" class="bb-modal-backdrop popup">
  <div class="bb-modal-card popup-box">

    <div class="bb-modal-header">
      <div class="bb-inline-flex bb-items-center bb-gap-12">
        <div class="bb-client-avatar">
          <img src="/assets/income.png" class="bb-w-100 bb-h-100 bb-rounded-full">
        </div>
        <h4>{{ 'expenses & revenue' | transloco }}</h4>
      </div>

      <button class="bb-modal-close" type="button" (click)="close()">×</button>
    </div>

    <div class="bb-form-grid">

      <div class="bb-field">
        <label class="bb-label">{{ 'amount' | transloco }}</label>
        <input class="bb-input" type="text" [(ngModel)]="amount" placeholder="{{ 'amount' | transloco }}" />
      </div>

      <div class="bb-field">
        <label class="bb-label">{{ 'note' | transloco }}</label>
        <input class="bb-input" type="text" [(ngModel)]="note" placeholder="{{ 'note' | transloco }}" />
      </div>

      <div class="bb-field bb-field-full">
        <label class="bb-label">{{ "payment_type" | transloco }}</label>
        <div class="bb-select-wrap">
          <select class="bb-select" [(ngModel)]="amount_type">
            <option value="0">{{ "cash" | transloco }}</option>
            <option value="1">{{ "vodafone cash" | transloco }}</option>
            <option value="2">{{ "instapay" | transloco }}</option>
            <option value="3">{{ "online payment" | transloco }}</option>
            <option value="4">{{ "bank transfer" | transloco }}</option>
            <option value="5">{{ "credit" | transloco }}</option>
          </select>
        </div>
      </div>

      <div class="bb-field bb-field-full">
        <div class="bb-modal-actions">
          <button (click)="onSubmit()" type="submit" class="bb-btn bb-btn-primary">
            {{ "Submit" | transloco }}
          </button>

          <button (click)="close()" class="bb-btn bb-btn-secondary">
            {{ "close" | transloco }}
          </button>
        </div>
      </div>

    </div>

  </div>
</div>